<template>
    <v-container>
        <div>
            <v-btn color="primary" @click="handleDataSync">Data Sync to Website</v-btn>
        </div>
    </v-container>
</template>

<script>
import { clients } from '@/util/clients';
import { mapActions, mapGetters } from 'vuex';

const { backendRest } = clients.direct;
export default {
  name: 'WebUtils',
  data() {
    return {
      baseCrudKey: 'webUtils',
      taxRollBaseCrudKey: 'TaxrollTransactionList',
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'criteria',
      'selectedTab',
      'index',
      'items',
      'highlightedId',
    ]),
    editedItem: {
      get() {
        return this.item(this.taxRollBaseCrudKey);
      },
      set(value) {
        this.setItem([this.taxRollBaseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapActions('SystemConfig', ['updateConfig']),
    ...mapActions(['flashInfo', 'flashSuccess']),
    ...mapActions(['reAuth', 'flashError']),
    async handleDataSync() {
      // Logic for syncing data to the website
      const response = await backendRest.post('/local-public/data-sync-to-web', this.editedItem);
      if (response && response.status !== 200) {
        this.flashError('Failed to sync data to the website.');
      } else {
        this.flashSuccess('Data successfully synced to the website.');
      }
    },
  },
};
</script>
